export const getSessionSettingsStorage = (key) => {
    const data = sessionStorage.getItem(`${window.vendor}@settings@${key}`);
    return !data ? null : JSON.parse(data);
};

export const setSessionSettingsStorage = (key, value) => {
    sessionStorage.setItem(`${window.vendor}@settings@${key}`, JSON.stringify(value));
};

export const removeSessionSettingsStorage = (key) => sessionStorage.removeItem(`${window.vendor}@settings@${key}`);
